{
  "RESET_PASSWORD": {
    "TITLE": "Zresetuj hasło",
    "DESCRIPTION": "Wprowadź adres e-mail, którego używasz do logowania się do centrum kontaktowego, aby otrzymać instrukcje resetowania hasła.",
    "GO_BACK_TO_LOGIN": "If you want to go back to the login page,",
    "EMAIL": {
      "LABEL": "E-mail",
      "PLACEHOLDER": "Wprowadź swój adres e-mail.",
      "ERROR": "Wprowadź poprawny adres e-mail."
    },
    "API": {
      "SUCCESS_MESSAGE": "Link do resetowania hasła został wysłany na Twój adres e-mail.",
      "ERROR_MESSAGE": "Nie można połączyć się z serwerem Woot. Spróbuj ponownie."
    },
    "SUBMIT": "Prześlij"
  }
}
